<template>
  <div>
      <div >

      <a-page-header title="Account Handlers">
        <template slot="extra">
          <a-button key="1" type="primary" @click="showAddModal()"
            >Add New Account Handler</a-button
          >
        </template>
      </a-page-header>
      
      <data-table
        id="table-wrapper"
        ref="accountHandlerDataTable"
        :columns="columns"
        :data-source="accountHandlerState.accountHandlers"
        :loading="loading"
        @refreshData="fetchAccountHandlers"
        :totalCount="accountHandlerState.accountHandlersCount"
        rowKey="id"
      >
         <span slot="country" slot-scope="record">
          {{ record.country.name  }}
        </span>
          <span slot="initial" slot-scope="record">
          {{ record.initial  }}
        </span>
         <span slot="city" slot-scope="record">
          {{ record.city  }}
        </span>
        <span slot="action" slot-scope="record">
          <a-tooltip title="Edit">
            <a class="edit-icon" @click="showEditModal(record.id)">
              <a-icon type="edit" />
            </a>
          </a-tooltip>
          <a-divider type="vertical" />
          <a-tooltip title="Delete">
            <a class="trash-icon" @click="confirmDelete(record.id)">
              <a-icon type="delete" /> </a
          ></a-tooltip>
        </span>
      </data-table>
      </div>
      <AccountHandlersModal
        v-model="isAccountHandlerModalVisible"
        :accountHandler="accountHandler"
        :title="modalTitle"
        :mode="mode"
      ></AccountHandlersModal>
    
  </div>
</template>
<script>
import {
     accountHandlerState,
      accountHandlerMutations,
  businessState,
} from "../../Store/store.js";
import AccountHandlersModal from "./AccountHandlersModal.vue";

const columns = [
  {
    title: "First Name",
    dataIndex: "firstname",
    key: "firstname",
    sorter: true,
    ellipsis: true,
  },
    {
    title: "Surename",
    dataIndex: "lastname",
    key: "lastname",
    sorter: true,
    ellipsis: true,
  },
  {
    title: "Initial",
    key: "initial",
    sorter: true,
    ellipsis: true,
    scopedSlots: { customRender: "initial" },
    textWrap: 'word-break',
  },
  {
    title: "Country",
    key: "country",
    scopedSlots: { customRender: "country" },
    ellipsis: true,
    sorter: true,
  },
  {
    title: "City",
    dataIndex: "city",
    key: "city",
    sorter: true,
    ellipsis: true,
  },
  {
    title: "Actions",
    key: "action",
    scopedSlots: { customRender: "action" },
    ellipsis: true,
    width: 70,
  },
];

export default {
  async mounted() {
    await this.fetchAccountHandlers();
    },
  data() {
    return {
      accountHandlerState,
      accountHandlerMutations,
      businessState,
      columns: columns,
      isSaving: false,
      loading: false,
      isAccountHandlerModalVisible: false,
      accountHandler: {},
      mode: "Add",
      modalTitle: "",
    };
  },
  methods: {
    async fetchAccountHandlers(params) {
      await accountHandlerMutations.setAccountHandler(params);
    },
    showAddModal() {
      this.mode = "Add";
      this.accountHandler = {};
      this.modalTitle = `${this.mode} Account Handler`;
      this.isAccountHandlerModalVisible = true;
    },
    showEditModal(recordId) {
      this.mode = "Update";
      this.accountHandler = {
        ...this.accountHandlerState.accountHandlers.find(
          (i) => i.id == recordId
        ),
      };
      this.modalTitle = `${this.mode} Account Handler`;
      this.isAccountHandlerModalVisible = true;
    },
    confirmDelete(accountHandlerId) {
      let self = this;
      this.$confirm({
        title: "Delete Account Handler?",
        content: "Are you sure you want to delete this account handler?",
        okText: "Delete",
        okType: "danger",
        cancelText: "Cancel",
        onOk() {
          self.deleteaccountHandler(accountHandlerId);
        },
        onCancel() {},
      });
    },
    async deleteaccountHandler(accountHandlerId) {
      try {
        let deleteResponse =
          await this.accountHandlerMutations.deleteAccountHandler(
            accountHandlerId
          );
        if (deleteResponse?.status == 200) {
          this.$message.success("Account handler deleted successfully!");
        }
      } catch (error) {
        this.showError(error);
      } finally {
        this.$refs.accountHandlerDataTable.refreshData(true);
      }
    },
  },
  components: {
    AccountHandlersModal
  },
};
</script>